import React from 'react';
import { Link } from 'gatsby';

export const LinkButton = ({ children, href, target = '', className = '' }) => {
  return (
    <Link
      to={href}
      target={target}
      className={`${className} block bg-blue-900 px-4 py-2 text-white font-medium cursor-pointer rounded hover:bg-blue-800`}>
      {children}
    </Link>
  );
};
